export default __webpack_public_path__ + "static/media/right_creative_mob.211536ee.png";